import { fromJS } from "immutable"
import {
  GET_LIST_DIMENSIONS_WATCHER,
  GET_LIST_DIMENSIONS_SUCCESS,
  GET_LIST_DIMENSIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: true,
  dimensionsTop: [],
  dimensionsBottom: [],
  dimensionsTopBenchmark: [],
  dimensionsBottomBenchmark: [],
})

function widgetListDimensionsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_DIMENSIONS_WATCHER:
      return state.set("isLoading", true)

    case GET_LIST_DIMENSIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set("dimensionsTop", action.payload.dimensions_top)
        .set("dimensionsBottom", action.payload.dimensions_bottom)
        .set("dimensionsTopBenchmark", action.payload.benchmark_dimensions_top)
        .set(
          "dimensionsBottomBenchmark",
          action.payload.benchmark_dimensions_bottom
        )

    case GET_LIST_DIMENSIONS_FAILED:
      return state
        .set("isLoading", false)
        .set("dimensionsTop", [])
        .set("dimensionsBottom", [])
        .set("dimensionsTopBenchmark", [])
        .set("dimensionsBottomBenchmark", [])

    default:
      return state
  }
}

export default widgetListDimensionsReducer
